import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {Input} from 'antd'
import {CloseCircleOutlined, SearchOutlined} from '@ant-design/icons'

import SearchResult from './SearchResult'

const SEARCH_DELAY = 500
let searchTimer

const EstateSearch = ({enableSearch, disableSearch}) => {
  const [pendingQuery, setPendingQuery] = useState('')
  const [searchQuery, setSearchQuery] = useState('')

  const updateQuery = (q) => {
    clearTimeout(searchTimer)
    setPendingQuery(q)

    if (q.length) {
      enableSearch()

      searchTimer = setTimeout(() => setSearchQuery(q), SEARCH_DELAY)
    }
    else {
      setSearchQuery('')
      disableSearch()
    }
  }

  const clearButton = <CloseCircleOutlined onClick={() => updateQuery('')} />
  const searchIcon = <SearchOutlined className="search-icon" />

  const queryFieldUpdated = (evt) => updateQuery(evt.target.value)

  const keyDown = (evt) => {
    const keyCode = evt.nativeEvent.code
    if (keyCode === 'Escape') {
      updateQuery('')
    }
    else if (keyCode === 'Enter') {
      clearTimeout(searchTimer)
      setSearchQuery(pendingQuery)
    }
  }

  return (
    <>
      <Input
        value={pendingQuery}
        onChange={queryFieldUpdated}
        onKeyDown={keyDown}
        prefix={searchIcon}
        suffix={pendingQuery ? clearButton : null}
        placeholder="Søk i oppdrag"
        className="search-input"
      />
      {!!searchQuery && (
        <SearchResult searchQuery={searchQuery} />
      )}
    </>
  )
}

EstateSearch.propTypes = {
  enableSearch: PropTypes.func,
  disableSearch: PropTypes.func,
}

export default EstateSearch
